export default "__VITE_ASSET__35761d2d__"